import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { QueryResult } from "@/api/utils/types"
import { WarrantsDcaTicketParser } from "@/models/admin/warrantsDcaTicket/warrantsDcaTicket.parser"
import { IWarrantsDcaTicket } from "@/models/admin/warrantsDcaTicket/warrantsDcaTicket.types"
import {
  Financials_Warrants_Dca_Tickets_Bool_Exp,
  Financials_Warrants_Dca_Tickets_Order_By,
  GetWarrantsDcaTicketsQuery,
} from "@/api/hasura/generated/graphql"

export interface WarrantsDcaTicketListResult {
  tickets: IWarrantsDcaTicket[]
  totalCount: number
}

/** "All Filters" selections applied to the DCA tickets table. */
export interface WarrantsDcaTicketFilters {
  /** Filter to a single warrants_dca_tickets_status, or null for any. */
  status: string | null
  /** Filter to a single warrants_ticket_type, or null for any. */
  type: string | null
  /** Filter to a single warrants_dca_type, or null for any. */
  dcaType: string | null
}

class WarrantsDcaTicketServiceClass {
  getTickets(
    search: string,
    filters: WarrantsDcaTicketFilters,
    page: number,
    pageSize: number,
    orderBy: Financials_Warrants_Dca_Tickets_Order_By,
  ): QueryResult<WarrantsDcaTicketListResult> {
    const where: Financials_Warrants_Dca_Tickets_Bool_Exp = {
      account_number: { _ilike: `%${search}%` },
    }
    if (filters.status) {
      where.status = { _eq: filters.status }
    }
    if (filters.type) {
      where.type = { _eq: filters.type }
    }
    if (filters.dcaType) {
      where.dca_type = { _eq: filters.dcaType }
    }

    return useQuery({
      ...HasuraQueries.warrants.dcaTickets(
        (page - 1) * pageSize,
        pageSize,
        where,
        orderBy,
      ),
      useRawResponse: true,
      placeholderData: { tickets: [], totalCount: 0 },
      parserFn: (
        data: GetWarrantsDcaTicketsQuery,
      ): WarrantsDcaTicketListResult => ({
        tickets: data.financials_warrants_dca_tickets.map(
          WarrantsDcaTicketParser.toDomain,
        ),
        totalCount:
          data.financials_warrants_dca_tickets_aggregate.aggregate?.count ?? 0,
      }),
    })
  }
}

export const WarrantsDcaTicketService = new WarrantsDcaTicketServiceClass()
